import { render, staticRenderFns } from "./BIMPaper.vue?vue&type=template&id=7aca4024&"
import script from "./BIMPaper.vue?vue&type=script&lang=js&"
export * from "./BIMPaper.vue?vue&type=script&lang=js&"
import style0 from "./BIMPaper.vue?vue&type=style&index=0&lang=less&module=true&"
import style1 from "./BIMPaper.vue?vue&type=style&index=1&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports